import React, { useEffect, useRef, useState } from 'react';
import Navbar from './Navbar';
import "./skills.css";
import Slider from "react-slick";
import BounceLoader from "react-spinners/BounceLoader";
import { gsap } from "gsap";
import Footer from './Footer';
import axios from 'axios';

const Skills = () => {
    // const baseURL = "https://my-portfolio-5u5m.onrender.com/"
     // const baseURL = "http://16.171.64.77/" this is aws ip
    //  const baseURL = "/api"; // this for proxy url

    const [hideLoader, setHideLoader] = useState(false)
    const el = useRef();
    const q = gsap.utils.selector(el);
    const [loading, setLoading] = useState(true);
    const [skillArr, setskillArr] = useState([])
    const [numColumns, setnumColumns] = useState("")
    const [columnWidth, setcolumnWidth] = useState("")

    useEffect(() => {
        document.title = "Skills"
    }, [])


    useEffect(() => {
        const reqURL = `/api/portfolio/skills/`

        axios.get(reqURL)
            .then(res => {
                setskillArr(res.data)
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
            })
    }, [])


    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    };

    const wheelRef = useRef();
    const mainRef = useRef();

    window.onscroll = function () {
        wheelRef.current.style.transform = "rotate(" + window.pageYOffset / 2 + "deg)";
    };

    useEffect(() => {

        if (!loading) {
            setHideLoader(true)
        }

    }, [loading])

    useEffect(() => {
        if (skillArr.length > 0) {

            const t3 = gsap.timeline();

            t3.from(".bars span", {
                opacity: 0,
                height: 0,
                stagger: 0.1,
                duration: 0.5,
                ease: "back",
            });

            return () => {
                t3.kill();
            };
        }
    }, [skillArr]);

    useEffect(() => {
        if (skillArr.length > 0) {

            setnumColumns(skillArr.length) // Calculate the number of columns dynamically
            setcolumnWidth(84 / numColumns + "%")
        }
    }, [skillArr])

    return (
        <>
            <div className="preloader" style={{ width: "100%", height: "100vh", background: "black", position: "fixed", top: "0", zIndex: "9999999", opacity: hideLoader && 0, visibility: hideLoader && "hidden", transition: "all 0.5s ease-in-out", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <BounceLoader color="#ff792e" size={100} />
            </div>
            <div ref={mainRef} className="mainCover" style={{ opacity: hideLoader && 1, transition: "all 0.5s ease-in-out" }}>
                <Navbar workRef={mainRef} textcolor="rgb(252, 246, 244)" />

                <section ref={el} className="myskillsSection">
                    <h1 className='bgHeading'>Skills</h1>
                    <div className="barChartWrapper">
                        <div className="barChart">
                            <div className="mainHeading">
                                <h1>My skills</h1>
                                <div className="underline">
                                    <span className="circle"></span>
                                    <span className="line"></span>
                                </div>
                            </div>
                            <div className='numbers tf'> <p>Newbie</p> </div>
                            <div className='numbers f'><p>Geek</p></div>
                            <div className='numbers sf'><p>Ninja</p></div>
                            <div className='numbers hun'><p>Jedi</p></div>
                            <div className="bars">
                                {
                                    skillArr.length === 0 ? null :
                                        skillArr.map((skill, ind) => {
                                            const percentage = skill.skill_level + "%"
                                            return (
                                                <span
                                                    className="html"
                                                    style={{
                                                        width: `${85 / skillArr.length}%`,
                                                        height: percentage,
                                                        borderColor: skill.skill_border_color,
                                                        backgroundColor: skill.skill_background_color,
                                                        backgroundImage: skill.skill_background_image

                                                    }}
                                                >
                                                    <p className='percentage'>{skill.skill_level} <div>%</div></p>
                                                    <p className='lable'>{skill.skill_name}</p>
                                                </span>
                                            )
                                        })
                                }
                                {/* <span className="html"> <p className='percentage'>90 <div>%</div></p>  <p className='lable'>HTML</p></span>
                                <span className="react">  <p className='percentage'>77 <div>%</div></p>  <p className='lable'>React Js</p></span>
                                <span className="css"> <p className='percentage'>87 <div>%</div></p>  <p className='lable'>CSS</p></span>
                                <span className="javascript">  <p className='percentage'>85 <div>%</div></p>  <p className='lable'>Javascript</p></span>
                                <span className="wordpress">  <p className='percentage'>90 <div>%</div></p>  <p className='lable'>Wordpress</p></span>
                                <span className="greensock">  <p className='percentage'>85 <div>%</div></p>  <p className='lable'>Java</p></span> */}
                            </div>
                        </div>
                    </div>

                    <div className="skillSlider">
                        <div className="sliderwrapper">
                            <div className="skillHeading">
                                <h1>Skills Info</h1>
                                <div className="underline">
                                    <span className="circle"></span>
                                    <span className="line"></span>
                                </div>
                            </div>
                            <Slider {...settings}>
                                {
                                    skillArr.map((skill, ind) => {
                                        return (
                                            <div key={ind} className="singskillwrapper">
                                                <div className="singleSkill">
                                                    <div className="skillLogo">
                                                        <i className={skill.skill_icon}></i>
                                                    </div>
                                                    <div className="skillcontent">
                                                        <h1 className='skillNumber'>0{ind + 1}</h1>
                                                        <h2 className="skillname">{skill.skill_name}</h2>
                                                        <p className="skillDescription">{skill.skill_description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </Slider>
                        </div>
                    </div>
                    <div className="rotationWheel">
                        <i ref={wheelRef} className="fas fa-yin-yang"></i>
                    </div>
                    <Footer />
                </section>
            </div>
        </>
    )
}

export default Skills;